var readCookie = function (name) {
    var nameEQ = name + "=";
    var cookieArr = document.cookie.split(';');
    for(var i=0;i < cookieArr.length;i++) {
        var itemVal = cookieArr[i];
        while (itemVal.charAt(0)==' ') itemVal = itemVal.substring(1,itemVal.length);
        if (itemVal.indexOf(nameEQ) == 0) return itemVal.substring(nameEQ.length,itemVal.length);
    }
    return null;
};
export default readCookie;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/readCookie.js